module.exports = __webpack_public_path__ + "img/hand-holding-magic.f67736cf.svg";